
import { mapState } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import WhatsappIntegrationUploadRestaurantDetails from "../reciever/whatsapp-integration-upload-restaurant-details.vue";

export default {
  components: {
    ResponsiveDialog,
    WhatsappIntegrationUploadRestaurantDetails
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    brandId: {
      type: Number,
      default: ""
    },
    channelsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isIdEntered: false,
      isRestaurantDetailsEntered: false,
      restaurantDetails: {}
    };
  },
  beforeMount() {
    const existingInput = this.getExistingData();
    if (existingInput) {
      this.restaurantDetails = existingInput;
    } else {
      this.restaurantDetails = {
        display_name: this.locationDetails?.restaurants[0]?.name,
        isWhatsappEnabled: "no",
        country_code: "+91",
        whatsapp_business_number: this.user?.mobile_number,
        website: "",
        email: this.user?.email,
        business_description: "",
        address:
          this.businessDetails?.locations[0]?.name ||
          this.businessDetails?.locations[0]?.address,
        restaurant_logo: this.user?.avatar_url,
        imgObj: {}
      };
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("restaurant", ["businessDetails", "locationDetails"])
  },
  methods: {
    getExistingData() {
      let matchingRestaurant = this.channelsList.find(
        (item) => item.id === this.brandId
      );
      let matchingChannel = matchingRestaurant.restaurant_platforms.find(
        (item) => item.id === this.$constants.Channels.WHATSAPP.id
      );
      return matchingChannel?.userInput;
    },

    handleRestaurantDetailsSubmition(e) {
      this.restaurantDetails = e;
      this.isRestaurantDetailsEntered = true;
      e = {
        ...e,
        name: this.$constants.Channels.WHATSAPP.name,
        restaurant_id: this.brandId
      };
      this.$emit("close-dialog", e);
    }
  }
};
